import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import PageTitle from '../../widgets/PageTitle/PageTitle';
import './FeaturesPage.scss';
import { useHistory, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import FashionPagination from '../../widgets/FashionPagination/FashionPagination';
import config from '../../config';
import {
  Container,
  Row,
  Col,
  Card,
  ListGroup,
  ListGroupItem,
  CardTitle,
  CardSubtitle,
  CardBody,
  CardText,
  FormGroup,
  Label,
  Input,
  CardImg,
} from 'reactstrap';
import dayjs from 'dayjs';
import blackDownArrow from '../../assets/images/common/black-down-arrow.png';
import {
  usePage,
  useTealium,
  useAdGlare,
  useUnmountResetPage,
  useNotFound,
  useDebounceLoading,
  useDelayJsLoadiing,
  useURLChangeCallback,
} from '../../utils/hookHelper';
import Loader from '../../components/Loader';
import { getDetailDataList } from '../../redux/modules/detailDataList/action';
import store from '../../redux/store';
import { getUrlSeoTitle, getFeaturesTitle } from '../../utils/UtilsClass';
import NoMatch from '../NoMatch';
import UnderConstruction from '../../components/UnderConstruction';
import HelmetMeta from '../../components/HelmetMeta';
import HelmetTitle from '../../components/HelmetTitle';
import HelmetStyle from '../../components/HelmetStyle';
import HelmetScript from '../../components/HelmetScript';
import HelmetHead from '../../components/HelmetHead';

const Features = (props) => {
  const {
    i18n,
    featuresDetail,
    featuresData,
    allowCookies,
    enableTealium,
    enableAdGlare,
    siteConfig,
  } = props;

  const FEATURES_PAGE_KEY = 'FEATURES_PAGE_KEY';

  const debouncePageLoading = useDebounceLoading(featuresData);
  const jsLoading = useDelayJsLoadiing(featuresData);
  const notFound = useNotFound(featuresData);

  usePage(null, config.pageType.featuresPage, null);
  useAdGlare(i18n.locale, siteConfig, featuresData, enableAdGlare.status);
  useUnmountResetPage();

  const siteConfigData = siteConfig.data || {};
  const { defaultLanguage } = siteConfigData;

  const { translations = {}, locale = defaultLanguage } = i18n || {};
  // const t = translations[locale] || {};

  const { data = [] } = featuresData || {};
  const content = Array.isArray(data) && data.length > 0 ? data[0] : {};
  const dataContent = content[locale] || {};
  const { under_construction = false } = content;

  // HelmetMeta
  const { topMetadata = {} } = content || {};
  const publishDate = topMetadata['TeamSite/LiveSite/PublishDate'];
  const seo = dataContent.seo || {};
  const { css_style_block = '', js_script_block = '', extra_head = '' } = content;

  const title = seo.seo_title;
  const [domTitle, setDomTitle] = useState('');
  const [isScriptReady, setIsScriptReady] = useState(false);

  const pageSize = 12;
  const defaultPage = 1;
  // const defaultSliceStart = 0;
  const [currentPage, setCurrentPage] = useState(defaultPage);
  // const [sliceStart, setSliceStart] = useState(defaultSliceStart);
  // const [sliceEnd, setSliceEnd] = useState(pageSize);

  useTealium(
    i18n.locale,
    siteConfig,
    {
      ...(featuresDetail[FEATURES_PAGE_KEY] || {}),
      CUSTOM_PAGE: {
        site_subsection: 'Features',
        page_name: 'Features Listing',
        page_type: 'section',
        nav_pageno: currentPage,
      },
    },
    allowCookies.status,
    enableTealium.status,
    domTitle,
  );

  useURLChangeCallback(locale, content, null, [], isScriptReady);

  // const helmetTitleCallBack = (newState) => {
  //   setDomTitle(newState.title);
  // };

  const helmetScriptCallBack = (isReady) => {
    setIsScriptReady(isReady);
  };

  const yearList = [
    { label: 'ALL', value: 0 },
    ...Array.from({ length: new Date().getFullYear() - 2014 + 1 }, (_, i) => {
      const year = new Date().getFullYear() - i;
      return {
        label: String(year),
        value: year,
      };
    }),
  ];

  // const heatList = [
  //   { value: 'MOST_RECENT', label: 'MOST RECENT' },
  //   { value: 'POPULAR', label: 'POPULAR' },
  // ];

  const [selectedYear, setSelectedYear] = useState(yearList[0].value);
  // const [selectedHeat, setSelectedHeat] = useState(heatList[0].value);

  // usePage(null, config.pageType.featuresDetailPage);
  // useUnmountResetPage();

  useEffect(() => {
    store.dispatch(
      getDetailDataList(
        FEATURES_PAGE_KEY,
        null,
        config.pageType.featuresDetailPage,
        ['displayStatus:true', selectedYear === yearList[0].value ? '' : `year:${selectedYear}`],
        currentPage === defaultPage ? 0 : (currentPage - 1) * pageSize,
        pageSize,
        'date', // `${selectedHeat === heatList[0].value ? 'date' : ''}`,
        true,
        null,
        null,
        true,
      ),
    );

    setDomTitle(`Features_Trigger_Tealium_Update${Date.now()}`);
  }, [currentPage, selectedYear]);

  const featuresDetailData = featuresDetail[FEATURES_PAGE_KEY]?.data || {};

  const featuresDetailArrays = featuresDetailData?.result || [];

  const curLang = i18n.locale;

  const handleYearChange = (event) => {
    setSelectedYear(Number(event.target.value));

    setCurrentPage(defaultPage);
    // setSliceStart(defaultSliceStart);
    // setSliceEnd(pageSize);
  };

  // const handleHeatChange = (event) => {
  //   setSelectedHeat(event.target.value);

  //   setCurrentPage(defaultPage);
  //   // setSliceStart(defaultSliceStart);
  //   // setSliceEnd(pageSize);
  // };

  // const dataList = useMemo(
  //   () =>
  //     featuresDetailArrays
  //       ?.filter((item) => selectedYear === 0 || dayjs(item.basicInfo.date).year() === selectedYear)
  //       ?.slice()
  //       ?.sort(
  //         (a, b) =>
  //           selectedHeat === 'MOST_RECENT' &&
  //           dayjs(b.basicInfo.date).unix() - dayjs(a.basicInfo.date).unix(),
  //       ),
  //   [featuresDetailArrays, selectedYear, selectedHeat],
  // );

  const pageTitle = {
    sc: '专题',
    en: 'FEATURES',
    tc: '專題',
  };

  const MemoizedCard = React.memo(({ item, index }) => {
    return (
      <Card className="features-card">
        <NavLink
          to={(location) => ({
            ...location,
            pathname: `${config.routePathTo}/${curLang}/highlight/${
              item.topMetadata.featureId
            }/${getUrlSeoTitle(getFeaturesTitle(item, 'en'))}-${dayjs(item.basicInfo.date).format(
              'YYYY-MM-DD',
            )}`,
            search: `?p1=${item.basicInfo.templateType}`,
          })}
        >
          <div className="card-container">
            <div className="content">
              <CardImg src={item.basicInfo.thumbnail} alt="error" />
              <div className="description">
                <div className="date">{dayjs(item.basicInfo.date).format('DD.MMM.YYYY')}</div>
                <div className="title">{getFeaturesTitle(item, curLang)}</div>
              </div>
            </div>
          </div>
        </NavLink>
      </Card>
    );
  });

  const clickPagination = useCallback(
    (currentPageNum, sliceStartNum, sliceEndNum) => {
      if (currentPageNum !== currentPage) {
        setCurrentPage(currentPageNum);
        // setSliceStart(sliceStartNum);
        // setSliceEnd(sliceEndNum);
      }
    },
    [currentPage],
  );

  // useEffect(() => {
  //   clickPagination(defaultPage, defaultSliceStart, pageSize);
  // }, [dataList]);

  const mainContent = (
    <div className="features-page">
      <Container>
        <Row>
          <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
            <PageTitle title={dataContent?.setting?.title} isFirst />
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="dropdown-col">
            <Input
              // id="yearSelect"
              name="select"
              type="select"
              value={selectedYear}
              onChange={handleYearChange}
              style={{
                background: `url(${blackDownArrow}) no-repeat right 10px center`,
              }}
              className="common-select"
            >
              {yearList.map((item, index) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </Input>
            {/* <Input
              // id="heatSelect"
              name="select"
              type="select"
              value={selectedHeat}
              onChange={handleHeatChange}
              style={{
                background: `url(${blackDownArrow}) no-repeat right 10px center`,
              }}
              className="common-select"
            >
              {heatList.map((item, index) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </Input> */}
          </Col>
        </Row>
        <div className="features-card-grid">
          {featuresDetailArrays?.map((item, index) => (
            <MemoizedCard
              key={`${item.topMetadata.featureId}${item.basicInfo.templateType}`}
              item={item}
              index={index}
            />
          ))}
        </div>
        <FashionPagination
          total={featuresDetailData?.total || 0}
          pageSize={pageSize}
          currentPage={currentPage}
          clickPagination={clickPagination}
        />
      </Container>
    </div>
  );

  const pageEle = notFound ? (
    <NoMatch />
  ) : (
    <>
      {under_construction && <UnderConstruction />}
      <h1 className="access-elem">{seo.seo_title}</h1>
      {!under_construction && mainContent}
      {!under_construction && (
        <HelmetScript
          helmetScriptCallBack={helmetScriptCallBack}
          extraHead={extra_head}
          jsScript={js_script_block}
        />
      )}
    </>
  );

  return (
    <>
      {debouncePageLoading || jsLoading ? <Loader /> : pageEle}
      {!debouncePageLoading && <HelmetHead extraHead={extra_head} />}
      {!debouncePageLoading && <HelmetStyle stylesheet={css_style_block} />}
      {!debouncePageLoading && <HelmetTitle title={title} />}
      {!debouncePageLoading && <HelmetMeta seo={seo} publishDate={publishDate} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  featuresDetail: state.detailDataList,
  featuresData: state.generalPage,
  allowCookies: state.allowCookies,
  enableTealium: state.enableTealium,
  enableAdGlare: state.enableAdGlare,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(Features);

export { Features as FeaturesComponent };
export default connectStore;
